<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="simulation.tostring + ' - ' + $t('Simulation')" routeBack="SimulationIndex"/>
      </div>


      <b-card :class="viable ? 'border-left-success' : 'border-left-fail'" class="mt-4 mb-4" no-body>
        <div v-if="viable" class="mx-4 my-1">
          <div class="row d-flex align-items-center justify-content-start mb-2">
            {{ $t('simulation.operation.result') + ' ' + $t('simulation.viability.viable') }}
          </div>
          <div class="row d-flex align-items-center justify-content-start">
            <div class="level-one-title main-green-color bold-text mr-3">
              {{ benefice + '€' }}
            </div>
            <div class="pastille-success level-two-title">
              {{ marge + '%' }}
            </div>
          </div>
        </div>
        <div v-else class="mx-4 my-1">
          <div class="row d-flex align-items-center justify-content-start mb-2">
            {{ $t('simulation.operation.result') + ' ' + $t('simulation.viability.nonviable') }}
          </div>
          <div class="row d-flex align-items-center justify-content-start">
            <div class="level-one-title main-red-color bold-text mr-3">
              {{ benefice + '€' }}
            </div>
            <div class="pastille-fail level-two-title">
              {{ marge + '%' }}
            </div>
          </div>
        </div>
      </b-card>

      <b-card v-if="simulation && simulation.documents && simulation.documents.length > 0">
        <div class="col-md-12">
          <div class="d-flex flex-column">
            <div class="bold-text"> {{ $t('Documents') }}</div>
            <b-link v-for="document in simulation.documents" :key="document.id" @click="downloadOldFile(document)">
              {{ document.fileName || document.name }}
            </b-link>
          </div>
        </div>
      </b-card>


      <b-card class="my-4">
        <div>
          <b-table id="table-field-simulation" :fields="tableFieldsSimulation"
                   :items="itemsSimulation"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   striped
                   style="margin-bottom: 0;">
            <template #cell(type)="data">
              <span v-if="data.value && data.value.includes('(Loué)')">
                {{ $t(data.value.replace('(Loué)', '')) }} <span class="loue-color">(Loué)</span>
              </span>
              <span v-else>
                {{ $t(data.value) }}
              </span>
            </template>
            <template #cell(HT)="data">
              <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
            </template>
            <template #cell(TVA)="data">
              <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
            </template>
            <template #cell(TTC)="data">
              <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
            </template>
          </b-table>
        </div>
      </b-card>

      <b-card class="my-4">
        <div>
          <b-table id="table-field-lot" :fields="tableFieldsLot"
                   :items="itemsLot"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   striped
                   style="margin-bottom: 0;">
            <template #cell(lot)="data">
              {{ $t(data.value) }}
            </template>
            <template #cell(HT)="data">
              <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
            </template>
            <template #cell(TVA)="data">
              <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
            </template>
            <template #cell(TTC)="data">
              <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
            </template>
          </b-table>
        </div>
      </b-card>

      <b-card class="mt-4 mb-4">
        <div>
          <b-table id="table-field-marge" :fields="tableFieldsMarge"
                   :items="itemsMarge"
                   :tbody-tr-class="rowClass"
                   :thead-class="'row-header'"
                   borderless
                   striped
                   style="margin-bottom: 0;">
            <template #cell(nom)="data">
              {{ $t(data.value) }}
            </template>
            <template #cell(taux)="data">
              <template v-if="data.value!==''"> {{ data.value + " %" }}</template>
            </template>
            <template #cell(TVA)="data">
              <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
            </template>
            <template #cell(TTC)="data">
              <template v-if="data.value!==''"> {{ data.value + " €" }}</template>
            </template>
          </b-table>
        </div>
      </b-card>

      <div class="row d-flex justify-content-end mb-4 mx-0">
        <b-button class="mr-2" variant="outline-primary" v-on:click="clickOnEditBtn()">
          {{ $t('Modify') + ' ' + $t('simulation') }}
        </b-button>
        <b-button v-if="operationId == null" class="ml-2" variant="primary" v-on:click="simulationToOperation()">
          {{ $t('simulation.to.operation') }}
        </b-button>
        <b-button v-else-if="operationId" class="ml-2" variant="primary" v-on:click="clickOnShowOperation()">
          {{ $t('See') + ' ' + $t('l.i') + $t('operation') }}
        </b-button>
      </div>

    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'

export default {

  name: "SimulationShow",

  components: {
    BackArrow
  },

  data() {
    return {
      simulationId: this.$route.params.simulationId,
      operationId: null,
      simulation: {},
      lotLimit: -1,
      isCollaborator: this.$store.getters.isCollaborator,
      isCollaboratorPlus: this.$store.getters.isCollaboratorPlus,
      viable: false,
      marge: null,
      benefice: null,

      tableFieldsSimulation: [
        {label: '', key: 'type'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsSimulation: [],

      tableFieldsLot: [
        {label: 'Lot', key: 'lot'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsLot: [],

      tableFieldsMarge: [
        {label: 'Nom', key: 'nom'},
        {label: '', key: 'taux', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'Montant', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsMarge: []
    }
  },

  computed: {
    getValue() {
      return property => (this.user[property] || this.user[property] === false) ? this.user[property] : 'N/A'
    },

    getValueArray() {
      return property => (this.user[property] && this.user[property].length) ? this.user[property].map(el => el.tostring).join(', ') : 'N/A'
    }

  },

  mounted() {
    this.fetchData()
  },

  methods: {

    downloadOldFile(file) {
      if (!file.hasOwnProperty('fileUrl')) {
        this.downloadNewFile(file)
        return
      }
      api({
        method: 'GET',
        url: file.fileUrl,
        responseType: 'blob'
      })
        .then(response => {
          let a = document.createElement('a')
          let blob = new Blob([response.data])
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = file.fileName
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },

    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.status === 'title-section-margin') return 'row-title-section row-margin'
      if (item.status === 'title-section') return 'row-title-section'
      else if (item.status === 'total-primary') return 'row-total-primary'
      else if (item.status === 'total-grey') return 'row-total-grey'
      else if (item.status === 'subtitle') return 'bold-text main-red-color'
    },

    fetchData() {
      this.fetchSimulation()
      this.fetchDataSimulation()
      this.fetchOperationId()
      this.getMaxNbLots()
    },

    fetchSimulation() {
      api
        .get(`/simulation/${this.simulationId}`)
        .then(response => {
          this.simulation = response.data
        })
        .catch((error) => {
          this.$router.push({
            name: 'SimulationIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    fetchOperationId() {
      api
        .get(`/operation/getOperationBySimulation/${this.simulationId}`)
        .then(response => {
          this.operationId = response.data.operationId
        })
        .catch((error) => {
          this.$router.push({
            name: 'SimulationShow',
            params: {
              simulationId: this.simulationId,
              message: error.response.data.message
            }
          })
        })
    },

    fetchDataSimulation() {
      api
        .get(`/simulation/getDataSimulation/${this.simulationId}`)
        .then(response => {
          this.itemsSimulation = response.data['itemsSimulation']
          this.itemsLot = response.data['itemsLot']
          this.itemsMarge = response.data['itemsMarge']
          this.marge = response.data['marge']
          this.viable = response.data['viable']
          this.benefice = response.data['benefice']
        })
        .catch((error) => {
          this.$router.push({
            name: 'SimulationIndex',
            params: {
              message: error.response.data.message
            }
          })
        })
    },


    clickOnEditBtn() {
      if (this.simulation && this.simulation.operationId) {
        this.$router.push({
          name: 'SimulationCreateEdit',
          params: {
            simulationId: this.simulation.id,
            isOperationLinked: true,
            operationId: this.simulation.operationId
          }
        })
      } else {
        this.$router.push({
          name: 'SimulationCreateEdit',
          params: {
            simulationId: this.simulation.id
          }
        })
      }
    },

    async showCustomConfirm(message, okText, cancelText) {
      return new Promise((resolve) => {
        this.$bvModal.msgBoxConfirm(message, {
          okTitle: okText,
          cancelTitle: cancelText,
          centered: true,
          okVariant: 'primary',
          cancelVariant: 'secondary',
        })
          .then((confirmed) => {
            resolve(confirmed);
          })
          .catch(() => {
            resolve(false);
          });
      });
    },

    async getMaxNbLots() {
      await api
        .get(`/operationLot/getMaxNbLots`)
        .then(response => {
          this.lotLimit = response.data
        })
    },

    async showPopup(){
      var okBtn = this.$i18n.t('SeeSubscription').toString()
      if(this.isCollaborator || this.isCollaboratorPlus) {
        okBtn = this.$i18n.t('Ok')
      }

      let message = "premium.no.more.operation"
      if(this.lotLimit > -1) {
        message = "premium.no.more.operationLot"
      }

      const confirmed = await this.showCustomConfirm(
        this.$i18n.t(message).toString(),
        okBtn,
        this.$i18n.t('Cancel')
      );

      if (confirmed && !this.isCollaborator && !this.isCollaboratorPlus) {
        this.$router.push({ name: 'ProfileShow' });
      }
    },

    async checkIfCanCreateNewOperation() {
      try {
        const response = await api.get(`/simulation/checkIfCanCreateNewOperation/${this.simulationId}`);
        return response.data.canCreate;
      } catch (error) {
        return false;
      }
    },

    async simulationToOperation() {
      const canCreate = await this.checkIfCanCreateNewOperation();
      if (canCreate) {
        this.$router.push({
          name: 'OperationCreate',
          params: {
            simulationId: this.simulationId,
            fromSimulation: true
          }
        })
      } else {
        await this.showPopup()
      }
    },

    clickOnShowOperation() {
      this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: this.operationId,
          currentSection: 0
        }
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}

</script>

<style scoped>
.loue-color {
  color: #6d84c4;
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/SimulationShow.vue